import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Link as MuiLink, Typography } from '@mui/material';

interface Props {
  hasOffer: boolean;
  opportunity: App.OpportunityPage;
}

export default function AccountOpportunityName({ hasOffer, opportunity }: Props) {
  const name = opportunity.opportunity_info?.name || opportunity.id;

  return hasOffer ? (
    <MuiLink component={Link} to={`/offers/${opportunity.id}/offer-builder`} fontWeight={600} underline="hover">
      {name}
    </MuiLink>
  ) : (
    <Typography component="span" fontWeight={600}>
      {name}
    </Typography>
  );
}
